import { Component } from '@angular/core';
import { AwButtonComponent } from '@components/misc/aw-button/aw-button.component';
import { CustomModalComponent } from '@components/misc/custom-modal/custom-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-introduction-modal',
    imports: [CustomModalComponent, TranslateModule, AwButtonComponent],
    templateUrl: './introduction-modal.component.html',
    styleUrl: './introduction-modal.component.scss'
})
export class IntroductionModalComponent {
    constructor(protected modalService: NgbModal) {}

    getIconPathByIndex(index: number) {
        switch (index) {
            case 0:
                return 'assets/icons/nav-icons-black/home.svg';
            case 1:
                return 'assets/icons/nav-icons-black/transactions.svg';
            case 2:
                return 'assets/icons/nav-icons-black/locations.svg';
            case 3:
                return 'assets/icons/nav-icons-black/device.svg';
            case 4:
                return 'assets/icons/nav-icons-black/users.svg';
            default:
                return '';
        }
    }

    getIconAltTextByIndex(index: number) {
        switch (index) {
            case 0:
                return 'Home';
            case 1:
                return 'Transactions';
            case 2:
                return 'Locations';
            case 3:
                return 'Devices';
            case 4:
                return 'Users';
            default:
                return '';
        }
    }
}
